import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule} from '@angular/material/form-field';
import { MatInputModule} from '@angular/material/input';
import { MatAutocompleteModule} from '@angular/material/autocomplete';
import { MatButtonModule} from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { GeoAutocompleteComponent } from './geo-auto-complete.component';
import { SanitizingModule } from '../sanitizing/sanitizing.module';


@NgModule({
    imports: [
      BrowserAnimationsModule,
      FormsModule,
      ReactiveFormsModule,
      MatFormFieldModule,
      MatInputModule,
      MatAutocompleteModule,
      MatIconModule,
      MatButtonModule,
      SanitizingModule
    ],
    exports: [
        GeoAutocompleteComponent
    ],
    declarations: [
        GeoAutocompleteComponent
    ],
    entryComponents: [
        GeoAutocompleteComponent
    ],
    providers: [
    ]
  })

  export class GeoAutoCompleteModule {
    constructor() {
    }
  }
